import * as store from "../lib/store";
import * as Icon from "./Icons";

export function Toasts() {
  return (
    <div class="toasts" role="status" aria-live="polite">
      {store.toasts.value.map((t) => (
        <div key={t.id} class={`toast ${t.kind}`}>
          {t.kind === "error" && <Icon.Warning />}
          <span>{t.text}</span>
          {t.action && (
            <button
              class="btn ghost toast-action"
              onClick={() => {
                // Dismissed first: the offer has been taken, and leaving it on
                // screen invites a second click that would undo the undo.
                store.dismiss(t.id);
                t.action?.run();
              }}
            >
              {t.action.label}
            </button>
          )}
          <button class="icon-btn" aria-label="Dismiss" onClick={() => store.dismiss(t.id)}>
            <Icon.Close />
          </button>
        </div>
      ))}
    </div>
  );
}
